var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { SheetDirection } from 'frontend/js/modules/infra/dls/components/sheet/type';
import { getViewerIdAndKind, isShopSessionView } from 'frontend/js/modules/infra/session';
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { useFeatureFlags } from 'frontend/js/modules/infra/feature-flags';
import { t } from '../../../../../infra/i18n';
import { Filters } from './filters';
import { endpoints } from '../../../network';
import { useApiQuery } from '../../../../../infra/api';
import { useSession } from '../../../../../infra/session/use-session';
import { buildStatusFilterArray } from './filter-utils';
import { sortOrders } from '../sort/use-table-sort';
import { EngageTracker } from '../../../tracking';
import { ENGAGE_CAMPAIGNS_LIST_FILTERED } from '../../../tracking/events';
import { useCanSeePromotionFilter } from '../../../hooks/use-can-see-promotion';
export var FiltersContainer = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, filters = _a.filters, sort = _a.sort;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var automatedCampaigns = useFeatureFlags().automatedCampaigns;
    var direction = isMobileOrSmaller ? SheetDirection.Bottom : SheetDirection.Right;
    var canSeePromotion = useCanSeePromotionFilter();
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var isShopKind = viewerIdAndKind.kind === 'shop';
    var _c = useState([]), creators = _c[0], setCreators = _c[1];
    var _d = useState(sort.sortName), localSort = _d[0], setLocalSort = _d[1];
    var _e = useState(filters.filterState.statusFilter), localStatus = _e[0], setLocalStatus = _e[1];
    var _f = useState(filters.filterState.typeFilter), localType = _f[0], setLocalType = _f[1];
    var _g = useState(filters.filterState.creatorFilter), localCreators = _g[0], setLocalCreators = _g[1];
    var creatorsByApiQuery = useApiQuery({
        endpoint: endpoints.campaignCreatorsFilterQuery,
        payload: { shopId: viewerIdAndKind.id },
        options: { enabled: isShopSessionView(session === null || session === void 0 ? void 0 : session.view) && !!viewerIdAndKind.id },
    }).data;
    useEffect(function () {
        var _a;
        if ((_a = creatorsByApiQuery === null || creatorsByApiQuery === void 0 ? void 0 : creatorsByApiQuery.ownerFilters) === null || _a === void 0 ? void 0 : _a.length) {
            var sorted = __spreadArray([], creatorsByApiQuery.ownerFilters, true).sort(function (a, b) { return a.firstName.localeCompare(b.firstName); });
            setCreators(sorted);
        }
    }, [creatorsByApiQuery]);
    useEffect(function () {
        if (open) {
            setLocalSort(sort.sortName);
            setLocalStatus(filters.filterState.statusFilter);
            setLocalType(filters.filterState.typeFilter);
            setLocalCreators(filters.filterState.creatorFilter);
        }
    }, [open, sort.sortName, filters]);
    var handleToggleCreator = function (id, checked) {
        setLocalCreators(function (current) { return (checked ? __spreadArray(__spreadArray([], current, true), [id], false) : current.filter(function (c) { return c !== id; })); });
    };
    var handleReset = function () {
        setLocalSort('createdAtDesc');
        setLocalStatus(undefined);
        setLocalType(undefined);
        setLocalCreators([]);
    };
    var handleShowResults = function () {
        sort.setSortName(localSort);
        filters.setStatusFilter(localStatus);
        filters.setTypeFilter(localType);
        filters.setCreatorFilter(localCreators);
        EngageTracker.getInstance().track(ENGAGE_CAMPAIGNS_LIST_FILTERED, {});
        onClose();
    };
    var previewCampaigns = useApiQuery({
        endpoint: endpoints.campaignsQuery,
        payload: {
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            perPage: 1,
            page: 1,
            type: localType,
            status: buildStatusFilterArray(localStatus),
            sortBy: sortOrders[localSort],
            search: filters.filterState.searchFilter || undefined,
            creatorIds: localCreators.length > 0 ? localCreators : undefined,
            engageNewFilters: true,
        },
        options: {
            enabled: !!viewerIdAndKind && open,
            keepPreviousData: true,
        },
    }).data;
    var resultsCount = ((_b = previewCampaigns === null || previewCampaigns === void 0 ? void 0 : previewCampaigns.pagination) === null || _b === void 0 ? void 0 : _b.count) || 0;
    var typeOptions = __spreadArray(__spreadArray([
        { value: 'update', label: t('engage:filters.quick_update') }
    ], (canSeePromotion ? [{ value: 'promotion', label: t('engage:filters.promotion') }] : []), true), (automatedCampaigns && isShopKind
        ? [{ value: 'automated', label: t('engage:filters.automated') }]
        : []), true);
    return (_jsx(Filters, { open: open, onClose: onClose, direction: direction, sortOrder: localSort, onSortChange: setLocalSort, status: localStatus, onStatusChange: setLocalStatus, type: localType, onTypeChange: setLocalType, creators: creators, creatorFilter: localCreators, onToggleCreator: handleToggleCreator, onReset: handleReset, onShowResults: handleShowResults, resultsCount: resultsCount, shouldShowCreators: isShopKind, typeOptions: typeOptions }));
};
